<template>
<v-app>
    <v-container fill-height>
        <v-row align="center" justify="center">

            <v-col cols="12" sm="12" md="4" lg="4">
                <div class="text-center">
                    <v-img :src="require('@/assets/image_logo.png/')" contain height="70" class="ma-2"></v-img>
                    <h2 class="mb-4">Cam-Feed</h2>
                </div>
                <div class="text-center">
                    <vue-telegram-login mode="callback" telegram-login="CamLoginBot" @callback="login" />

                </div>
                <div class="google">
                    <div ref="googleLoginBtn"></div>
                </div>
                <div class="mt-5 text-center">
                  <a style="text-decoration: none;" target="_blank" href="https://drive.google.com/file/d/1bbU2W1O0x8GL54ofPW7mIAwDMeCIeGXX/view?usp=drive_link">Download Extension</a>
                </div>

            </v-col>

        </v-row>
    </v-container>

</v-app>
</template>

    
    
<script>
import {
    vueTelegramLogin
} from "vue-telegram-login";
import axios from 'axios'
export default {
    name: "your-component",
    components: {
        vueTelegramLogin
    },
    data() {
        return {
            userInfo: ''
        }
    },
    created() {
        var hasLogin = localStorage.getItem('hasLogin')

        if (hasLogin) {

            this.$router.push('dashboard')
        }

    },
    mounted() {
        // this.getUser();

       
     
        setTimeout(() => { 
          const gClientId = "163544297487-qtenifb5d4f8cfmud88jsmr9lotdkjkp.apps.googleusercontent.com"
              window.google.accounts.id.initialize({
                client_id: gClientId,
                callback: this.handleCredentialResponse,
                auto_select: true
            })
            window.google.accounts.id.renderButton(
                this.$refs.googleLoginBtn, {
                    text: 'signup_with', // or 'signup_with' | 'continue_with' | 'signin'
                    size: 'large', // or 'small' | 'medium'
                    width: '240', // max width 400
                    theme: 'filled_blue', // or 'filled_black' |  'filled_blue' \ outline
                    logo_alignment: '' // or 'center'
                }
            )



        }, 200)
        // window.google.accounts.id.prompt(); 
    },
    methods: {
        handleCredentialResponse(response) {

            if (response.credential != '' || response.credential != undefined) {
                var user = this.parseJwt(response.credential)
                this.saveUser(user.sub, user.name, user.email)
            }

            // Put your backend code in here
        },
        parseJwt(token) {
            // Decode the JWT token to get the payload
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            return JSON.parse(jsonPayload); // Parse and return the JSON payload
        },
        login(user) {

            var id_tele = user['id'];
            var username = user['username'];
            this.saveUser(id_tele, username, "");
        },
        getUser() {
            this.userInfo = this.$cookies.get('usertg')
            console.log(this.userInfo)
        },
        logout() {

        },
        saveUser(id_tele, username, email) {

            var bodyFormData = new FormData();
            bodyFormData.append('id_tele', id_tele);
            bodyFormData.append('username', username);
            bodyFormData.append('email', email);
            axios.post('https://app.camsmartbiz.com/user/loginwithtelegram', bodyFormData).then((data) => {

                this.$store.commit("setAuthentication", true);
                this.$router.push({
                    name: "dashboard"
                });
                window.localStorage.setItem('info', JSON.stringify(data.data))
                window.localStorage.setItem('hasLogin', true)

            }).catch((error) => {

                console.log(error)

            }).finally((data) => {

            })

        }
    }
};
</script>
   
<style>
/* @media only screen and (min-width: 700px) {

    .google {
      margin-left: 220px;
    }
} */

@media only screen and (max-width: 390px) {
  .google {
      margin-left: 50px;
    }
}

@media only screen and (min-width: 400px) {
  .google {
      margin-left: 80px;
    }
}


@media only screen and (min-width: 768px) {
  .google {
      margin-left: 270px;
    }
}

@media only screen and (min-width: 992px) {
  .google {
      margin-left: 20px;
    }
  }

@media only screen and (min-width: 1200px) {
  .google {
    margin-left: 170px;
    }
}
</style>
